import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconChannelIterable = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <path
          opacity="0.25"
          d="M18.6573 9.82065L9.90918 18.5687L14.3161 22.9757L23.0642 14.2276L18.6573 9.82065Z"
          fill="#59C1A7"
        />
        <path
          opacity="0.25"
          d="M14.2575 1.00067L9.85059 5.40759L18.5987 14.1557L23.0056 9.74874L14.2575 1.00067Z"
          fill="#36C3F2"
        />
        <path
          opacity="0.15"
          d="M5.3747 9.82611L0.967773 14.233L9.71585 22.9811L14.1228 18.5742L5.3747 9.82611Z"
          fill="#EF3D55"
        />
        <path
          opacity="0.15"
          d="M9.92288 0.793791L1.1748 9.54187L5.58173 13.9488L14.3298 5.20072L9.92288 0.793791Z"
          fill="#6A266D"
        />
        <path
          d="M12.0018 6.27891C13.7356 6.27891 15.1412 4.87333 15.1412 3.13945C15.1412 1.40558 13.7356 0 12.0018 0C10.2679 0 8.8623 1.40558 8.8623 3.13945C8.8623 4.87333 10.2679 6.27891 12.0018 6.27891Z"
          fill="#6A266D"
        />
        <path
          d="M20.8602 15.1738C22.594 15.1738 23.9996 13.7682 23.9996 12.0344C23.9996 10.3005 22.594 8.8949 20.8602 8.8949C19.1263 8.8949 17.7207 10.3005 17.7207 12.0344C17.7207 13.7682 19.1263 15.1738 20.8602 15.1738Z"
          fill="#36C3F2"
        />
        <path
          d="M12.0018 24.0343C13.7356 24.0343 15.1412 22.6287 15.1412 20.8948C15.1412 19.161 13.7356 17.7554 12.0018 17.7554C10.2679 17.7554 8.8623 19.161 8.8623 20.8948C8.8623 22.6287 10.2679 24.0343 12.0018 24.0343Z"
          fill="#59C1A7"
        />
        <path
          d="M3.13945 15.1395C4.87332 15.1395 6.27891 13.7339 6.27891 12C6.27891 10.2662 4.87332 8.8606 3.13945 8.8606C1.40558 8.8606 0 10.2662 0 12C0 13.7339 1.40558 15.1395 3.13945 15.1395Z"
          fill="#EF3D55"
        />
      </SvgIcon>
    );
  })
);
